module.exports = __webpack_public_path__ + "img/biberkopf.85902bd8.jpg";